import React, { useState } from 'react';
import { ToastContainer , toast } from 'react-toastify';
const API = process.env.REACT_APP_API_URL

console.log('api for email',API)

export default function BookDemo({ onClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);

    const formData = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      preferredDate: e.target.preferredDate.value,
      timeSlot: e.target.timeSlot.value,
      companyScale: e.target.companyScale.value,
    };

    try {
      const response = await fetch(`${API}/email/send-demo-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      console.log('response',response)

      const result = await response.json();

      if (result.success) {
        toast.success(
      `Our team will contact you soon.`,
      `Demo Request Sent!`,
      3000
    )
        setMessage({ type: 'success', text: 'Demo request sent! Our team will contact you soon.' });
        console.log('message sented')
        e.target.reset();
        setTimeout(() => onClose(), 2000);
      } else {
        setMessage({ type: 'error', text: result.message || 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      toast.error(
        'Something went wrong',
        'Failed',3000
      )
      console.log('getting error',error)
      setMessage({ type: 'error', text: 'Network error. Please check your connection.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-md flex items-center justify-center z-[100] animate-fadeIn p-4">
      <div className="w-full max-w-[400px] rounded-[2rem] bg-white shadow-2xl relative overflow-hidden animate-scaleIn border border-slate-100">
        
        {/* HEADER */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 py-7 px-8 relative text-center">
          <button
            onClick={onClose}
            className="absolute top-4 right-5 text-blue-100 hover:text-white transition-colors bg-white/10 w-8 h-8 rounded-full flex items-center justify-center backdrop-blur-sm"
          >
            ✕
          </button>
          
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center backdrop-blur-md mb-3 border border-white/20">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-2xl font-black text-white tracking-tight">Request a Demo</h2>
            <p className="text-blue-100 text-xs mt-1 font-medium opacity-90 uppercase tracking-widest">Experience Adeya IMS</p>
          </div>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="p-7 space-y-4">
          
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">First Name</label>
              <input 
                name="firstName"
                placeholder="John" 
                required
                className="w-full px-4 py-2.5 text-sm rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 focus:border-blue-500 outline-none transition-all font-medium text-slate-700" 
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Last Name</label>
              <input 
                name="lastName"
                placeholder="Doe" 
                required
                className="w-full px-4 py-2.5 text-sm rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 focus:border-blue-500 outline-none transition-all font-medium text-slate-700" 
              />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Business Email</label>
            <input 
              type="email" 
              name="email"
              placeholder="john@company.com" 
              required
              className="w-full px-4 py-2.5 text-sm rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 focus:border-blue-500 outline-none transition-all font-medium text-slate-700" 
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Preferred Date</label>
              <input 
                type="date" 
                name="preferredDate"
                required
                className="w-full px-4 py-2.5 rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 outline-none text-xs font-bold text-slate-600" 
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Time Slot</label>
              <select 
                name="timeSlot"
                required
                className="w-full px-4 py-2.5 rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 outline-none text-xs font-semibold text-slate-600"
              >
                <option value="">Select</option>
                <option>10:00 AM - 12:00 PM</option>
                <option>12:00 PM - 2:00 PM</option>
                <option>2:00 PM - 4:00 PM</option>
                <option>4:00 PM - 6:00 PM</option> 
              </select>
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Company Scale</label>
            <textarea
              name="companyScale"
              placeholder="Briefly describe your inventory needs..."
              rows="2"
              className="w-full px-4 py-2.5 text-sm rounded-xl border border-slate-100 bg-slate-50 focus:bg-white focus:ring-4 focus:ring-blue-50 outline-none transition-all resize-none font-medium text-slate-700"
            ></textarea>
          </div>

          {message && (
            <div className={`p-3 rounded-xl text-sm font-medium text-center ${
              message.type === 'success' 
                ? 'bg-green-50 text-green-700 border border-green-200' 
                : 'bg-red-50 text-red-700 border border-red-200'
            }`}>
              {message.text}
            </div>
          )}

          <button 
            type="submit"
            disabled={isLoading}
            className={`w-full bg-slate-900 text-white py-4 rounded-2xl font-black text-sm hover:bg-blue-600 shadow-xl shadow-slate-200 hover:shadow-blue-200 active:scale-[0.98] transition-all duration-300 uppercase tracking-widest ${
              isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isLoading ? 'SENDING...' : 'BOOK FREE DEMO'}
          </button>

          <p className="text-center text-[10px] text-slate-400 font-medium px-4 leading-relaxed">
            Our team will contact you to confirm the final technical walkthrough.
          </p>
        </form>

      </div>
    </div>
    </>
  );
}